import { MDBDatatable, MDBIcon } from 'mdb-react-ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import PopupLoaderNew from '../../popups/PopupLoaderNew';
import DeleteTrustedDevice from '../../popups/securitymanager/DeleteTrustedDevice';

function TrustedDevice(props) {
    const [trustDevices, settrustDevices] = useState([]);
    const [deleteip, setdeleteip] = useState(false);
    const toggledelete = () => setdeleteip(!deleteip);
    const [trustid, setTrustid] = useState("");
    const [isLoading, setisLoading] = useState(false);
    const addUserRef = useRef(null);

    function handleClick() {
        addUserRef.current.click();
    }

    useEffect(() => {
        if (props.trustedDevices && props.trustedDevices.length > 0) {
            settrustDevices(props.trustedDevices);
        }

    }, [props.trustedDevices]);

    const handleDeleteTrustedDevice = (e, deviceInfo) => {
        e.preventDefault();
        console.log(JSON.stringify(deviceInfo));
        setTrustid(deviceInfo.device_id);
        toggledelete();
    }

    let processdrows = [];
    trustDevices.map((device) => {
        processdrows.push({
            deviceInfo: { ...device },
            devicename: device.Device_name,
            host: device.host,
            browsername: device.browser_name,
            delete: (
                <div className="d-flex align-items-center justify-content-center">
                    <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => handleDeleteTrustedDevice(e, device)}>
                        <MDBIcon fas icon="times" color="primary"
                            // onClick={(e) => handleAuthUserDelete(e, auth)} 
                            className="mx-2 fs-5" />
                    </div>
                </div>
            ),

        })
    })
    const SelecttheDevice = {
        columns: [
            { label: 'Device Name', field: 'devicename' },
            { label: 'Host', field: 'host' },
            { label: 'Browser Name', field: 'browsername' },
            { label: 'Delete', field: 'delete', sort: false },
        ],
        rows: processdrows,
        // [
        //     {
        //         deviceName: 'nikhilone@dynamic, chithratwo@dynamic, rahulonee@dynamic, dsaione@dynamic, raghuseven@dynamic, raghusix@dynamic, raghufive@dynamic, raghutwo@dynamic, raghuone@dynamic',
        //         host: '49.206.51.223',
        //         browserName: 'Chrome',
        //         delete: (
        //             <div className="d-flex align-items-center justify-content-center">
        //                 <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip">
        //                     <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
        //                 </div>
        //             </div>
        //         ),
        //     },
        //     {
        //         deviceName: 'raghutwo@dynamic',
        //         host: '183.82.126.90',
        //         browserName: 'Chrome',
        //         delete: (
        //             <div className="d-flex align-items-center justify-content-center">
        //                 <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip">
        //                     <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
        //                 </div>
        //             </div>
        //         ),
        //     },
        // ],
    };

    return (
        <>
            <div className="actionbar"></div>

            <div className="SecutityTopViewPage1">
                <MDBDatatable className='actioncolumn' search hover data={SelecttheDevice} sortField="Device Name" entries={50} />
            </div>
            {deleteip && (
                <PopupLoaderNew
                    title={"delete Trusted Device"}
                    content={<DeleteTrustedDevice
                        id={trustid}
                        onClose={toggledelete}
                        ref={addUserRef}
                        setIsloading={setisLoading}
                    />}
                    onShow={setdeleteip}
                    onClose={toggledelete}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}
        </>
    )
}

export default TrustedDevice
